import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Form, Modal } from 'react-bootstrap';
import LoadThongTinService from '../../services/LoadThongTinService';
import DriverService from '../../services/DriverService';
import MapPreview from './MapPreview'; // Component hiển thị định tuyến cho tài xế
import './style.css'; // Import file CSS

const TaiXeNhanChuyenComponent = () => {
  const [chuyenData, setChuyenData] = useState([]);
  const [selectedChuyen, setSelectedChuyen] = useState(null);
  const [currentStatus, setCurrentStatus] = useState('');
  const [modalMode, setModalMode] = useState(''); // "receive", "view" hoặc "kmPhatSinh"
  const [thayDoi, setThayDoi] = useState(false);
  const [assignBuuTa, setAssignBuuTa] = useState(null);
  const [formData, setFormData] = useState({
    maChuyen: '',
    ma_cx: '',
    kmDau: '',
    kmNhanHang: '',
    kmCuoi: '',
    kmPhatSinh: '',
    anhNhanHang: null,
    anhGiaoHang: null,
    trangThaiKetThuc: 'Về thùng rỗng',
    buuTa: '', // Thêm buuTa vào formData để dễ điều khiển    
    // Thêm các trường datetime
    timeNhanChuyen: '',
    timeNhanHang: '',
    timeGiaoHangXong: '',
    timeVeKho: '',
  });
  const [showModal, setShowModal] = useState(false);
  const [kmPhatSinhMessage, setKmPhatSinhMessage] = useState('');

  // Lấy danh sách chuyến
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await LoadThongTinService.getChuyenData();
        setChuyenData(data);
        setThayDoi(false);
      } catch (err) {
        console.error("Error fetching data:", err);
        alert(`Failed to fetch data: ${err.message}`);
      }
    };
    fetchData();
  }, [thayDoi]);

  // Lấy thông tin Bưu tá (từ phía server) cho một chuyến
  const getBuuTa = async (maChuyen) => {
    try {
      const response = await DriverService.getBuuTa(maChuyen);
      return response.data;
    } catch (error) {
      console.error(`Error getting Bưu tá for trip ${maChuyen}:`, error);
      throw new Error('Không thể lấy thông tin Bưu tá.');
    }
  };

  // Bổ sung hàm này để khi click "Cập nhật chuyến" hoặc "Kết thúc chuyến" thì lấy Bưu tá cũ:
  const handleFetchAndSetBuuTa = async (maChuyen) => {
    try {
      const buuTaInfo = await getBuuTa(maChuyen);
      console.log(buuTaInfo);
      // Ví dụ backend trả về { success: true, buu_ta: "810239 - Đặng Toàn Quốc" }
      if (buuTaInfo?.buu_ta) {
        setAssignBuuTa(buuTaInfo.buu_ta);
        setFormData(prev => ({ ...prev, buuTa: buuTaInfo.buu_ta }));
      } else {
        setAssignBuuTa(null);
        setFormData(prev => ({ ...prev, buuTa: '' }));
      }
    } catch (error) {
      console.error('Error fetching Bưu tá:', error);
    }
  };

  // Khi bấm "Nhận chuyến"/"Cập nhật"/"Kết thúc" => mở modal (dạng form)
  const handleButtonClick = async (chuyen) => {
    setSelectedChuyen(chuyen);
    setCurrentStatus(chuyen.trang_thai);
    setFormData((prevData) => ({
      ...prevData,
      maChuyen: chuyen.id,
      buuTa: '' // Reset trước (phòng trường hợp chuyến chưa có Bưu tá)
    }));

    // Nếu là chuyến đã nhận hoặc đang cập nhật, ta tự động lấy Bưu tá cũ
    if (chuyen.trang_thai === 'da_nhan' || chuyen.trang_thai === 'capnhat_chuyen') {
      await handleFetchAndSetBuuTa(chuyen.id);
    }

    setModalMode("receive");
    setShowModal(true);
  };

  // Khi bấm "Xem đường đi" => mở modal (dạng view)
  const handleViewRouteClick = (chuyen) => {
    setSelectedChuyen(chuyen);
    setModalMode("view");
    setShowModal(true);
  };

  // Thay đổi formData
  const handleFormChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  // Input helper
  const renderInputField = (label, field, type = 'text', options = null, accept = null, selectValue = '') => (
    <Form.Group className="mb-3">
      <Form.Label>{label}</Form.Label>
      {type === 'select' ? (
        <Form.Select
          value={selectValue}
          onChange={(e) => handleFormChange(field, e.target.value)}
          required
        >
          <option value="" disabled hidden>Chọn một tùy chọn</option>
          {options && options.map((option, index) => (
            <option key={index} value={option}>{option}</option>
          ))}
        </Form.Select>
      ) : (
        <Form.Control
          type={type}
          onChange={(e) =>
            handleFormChange(field, type === 'file' ? e.target.files[0] : e.target.value)
          }
          accept={accept}
          required
        />
      )}
    </Form.Group>
  );

  // Render nội dung form tùy theo trạng thái
  const generateFormContent = () => {
    switch (currentStatus) {
      case 'chua_nhan':
        return (
          <>
            {renderInputField('Mã Chuyến VTMan', 'ma_cx', 'text')}
            {renderInputField('Km đầu', 'kmDau', 'number')}
            {/* Thời gian nhận chuyến */}
            {renderInputField('Thời gian nhận chuyến', 'timeNhanChuyen', 'datetime-local')}
          </>
        );

      case 'da_nhan':
        return (
          <>
            {renderInputField('Km nhận hàng', 'kmNhanHang', 'number')}
            {renderInputField('Ảnh nhận hàng', 'anhNhanHang', 'file', null, 'image/*')}
            {renderInputField(
              'Chọn Bưu tá',
              'buuTa',
              'select',
              [
                "207415 - Bùi Tất Thành",
                "810239 - Đặng Toàn Quốc",
                "818333 - Lê Hoàng Xuân Bắc",
                "822665 - Ngô Thời Minh Trí",
                "822684 - Nguyễn Minh Đăng",
                "813956 - Nguyễn Quang Vinh",
                "805905 - Dương Bá Quân",
                "810280 - Nguyễn Thanh Trường Thi",
                "810240 - Huỳnh Quốc Bảo",
                "822658 - Phùng Ngọc Tân",
                "801082 - Huỳnh Sử Thanh",
                "823824 - Phan Văn Hiến",
                "829282 - Nguyễn Hoàng Long",
                "829261 - Hoàng Hữu Phong",
                "829695 - Ngô Nhật Anh",
                "292631 - Nguyễn Ngọc Thọ",
                "831244 - Nông Quốc An Khang",
                "831243 - Lộc Nam Hải",
                "831242 - Nguyễn Văn Hậu",
                "831738 - Nguyễn Quốc Nhuẫn",
                "832698 - Lê Thành Thái",
                "832702 - Nguyễn Phi Hoàng",
                "832697 - Nguyễn Hoàng Tiến",
                "832711 - Nguyễn Hoàng Đại Thành",
                "838990 - Hoàng Gia Huy",
                "000001 - Bưu tá OS",
                "Không có/Chưa có"
              ],
              null,
              formData.buuTa
            )}
            {/* Thời gian nhận hàng */}
            {renderInputField('Thời gian nhận hàng', 'timeNhanHang', 'datetime-local')}
          </>
        );

      case 'capnhat_chuyen':
        return (
          <>
            {renderInputField('Km cuối', 'kmCuoi', 'number')}
            {renderInputField('Ảnh giao hàng', 'anhGiaoHang', 'file', null, 'image/*')}
            {renderInputField('Chọn hành động tiếp theo', 'trangThaiKetThuc', 'select', [
              "Về thùng rỗng",
              "Đã nhận phát hàng bưu chính",
              "Đã nhận chuyên khác"
            ])}
            {renderInputField(
              'Chọn Bưu tá',
              'buuTa',
              'select',
              [
                "207415 - Bùi Tất Thành",
                "810239 - Đặng Toàn Quốc",
                "818333 - Lê Hoàng Xuân Bắc",
                "822665 - Ngô Thời Minh Trí",
                "822684 - Nguyễn Minh Đăng",
                "813956 - Nguyễn Quang Vinh",
                "805905 - Dương Bá Quân",
                "810280 - Nguyễn Thanh Trường Thi",
                "810240 - Huỳnh Quốc Bảo",
                "822658 - Phùng Ngọc Tân",
                "801082 - Huỳnh Sử Thanh",
                "823824 - Phan Văn Hiến",
                "829282 - Nguyễn Hoàng Long",
                "829261 - Hoàng Hữu Phong",
                "829695 - Ngô Nhật Anh",
                "292631 - Nguyễn Ngọc Thọ",
                "831244 - Nông Quốc An Khang",
                "831243 - Lộc Nam Hải",
                "831242 - Nguyễn Văn Hậu",
                "831738 - Nguyễn Quốc Nhuẫn",
                "832698 - Lê Thành Thái",
                "832702 - Nguyễn Phi Hoàng",
                "832697 - Nguyễn Hoàng Tiến",
                "832711 - Nguyễn Hoàng Đại Thành",
                "838990 - Hoàng Gia Huy",
                "000001 - Bưu tá OS",
                "Không có"
              ],
              null,
              formData.buuTa
            )}
            {/* Thời gian giao hàng xong */}
            {renderInputField('Thời gian giao hàng xong', 'timeGiaoHangXong', 'datetime-local')}
          </>
        );

      case 'hoan_tat':
        return (
          <>
            {renderInputField('Nhập Km phát sinh', 'kmPhatSinh', 'number')}
            {/* Thời gian về kho */}
            {renderInputField('Thời gian về kho', 'timeVeKho', 'datetime-local')}
          </>
        );

      default:
        return null;
    }
  };

  // Hàm chuyển đổi và resize ảnh (nếu là HEIC thì chuyển sang JPEG)
  async function resizeImage(file, maxWidth = 800, quality = 0.7) {
    if (file.type === 'image/heic') {
      try {
        const heic2any = (await import('heic2any')).default;
        const convertedBlob = await heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: quality
        });
        file = new File([convertedBlob], file.name.replace('.heic', '.jpeg'), {
          type: 'image/jpeg'
        });
      } catch (error) {
        console.error('Error converting HEIC image:', error);
        throw new Error('Failed to convert HEIC image');
      }
    }

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = function (e) {
        const img = new Image();
        img.src = e.target.result;
        img.onload = function () {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          const scaleSize = maxWidth / img.width;
          canvas.width = maxWidth;
          canvas.height = img.height * scaleSize;
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          canvas.toBlob((blob) => {
            const resizedFile = new File([blob], file.name, { type: file.type });
            resolve(resizedFile);
          }, 'image/jpeg', quality);
        };
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  }

  // Khi tài xế bấm hoàn thành chuyến (hoan_tat + xác nhận)
  const handleEndButtonClick = async (maChuyen) => {
    try {
      const isConfirmed = window.confirm(`Xác nhận hoàn thành chuyến ${maChuyen}. (Về kho)`);
      if (!isConfirmed) return;

      const result = await DriverService.hoanThanhChuyen(maChuyen);
      setKmPhatSinhMessage(result.message);
      setModalMode("kmPhatSinh");
      setSelectedChuyen({ id: maChuyen });
      setShowModal(true);
    } catch (error) {
      alert('Lỗi khi hoàn thành chuyến: ' + error.message);
    }
  };

  // Xử lý nhập km phát sinh sau khi đã hoàn thành
  const handleKmPhatSinhConfirm = async () => {
    try {
      if (formData.kmPhatSinh <= 0 || isNaN(formData.kmPhatSinh)) {
        alert("Km phát sinh phải là số nguyên dương!");
        return;
      }
      const result = await DriverService.nhapKmPhatSinh(formData.kmPhatSinh, formData.timeVeKho, selectedChuyen.id);
      alert(result.message);

      // Cập nhật km_phat_sinh trong danh sách chuyến
      setChuyenData((prevData) =>
        prevData.map((chuyen) =>
          chuyen.id === selectedChuyen.id
            ? { ...chuyen, km_phat_sinh: formData.kmPhatSinh }
            : chuyen
        )
      );
      setShowModal(false);
      setThayDoi(true);
    } catch (error) {
      alert('Lỗi khi cập nhật Km phát sinh: ' + error.message);
    }
  };

  // Mở modal nhập Km phát sinh nếu chuyến đã hoàn tất
  const handleNhapKmPhatSinh = (chuyen) => {
    setSelectedChuyen(chuyen);
    setModalMode("kmPhatSinh");
    setShowModal(true);
  };

  // Gửi form khi bấm "Xác nhận"
  const submitForm = async () => {
    let urlService;
    if (currentStatus === 'chua_nhan') {
      urlService = DriverService.nhanChuyen;
    } else if (currentStatus === 'da_nhan') {
      urlService = DriverService.capNhatChuyen;

      // Kiểm tra Bưu tá
      if (!formData.buuTa) {
        alert("Vui lòng chọn Bưu tá!");
        return;
      }
      // Gán Bưu tá
      const dataBuuTa = new FormData();
      dataBuuTa.append("buuTa", formData.buuTa);
      const result = await DriverService.ganBuuTa(selectedChuyen.id, dataBuuTa);
      alert(result.message);

    } else if (currentStatus === 'capnhat_chuyen') {
      urlService = DriverService.ketThucChuyen;

      if (!formData.buuTa) {
        alert("Vui lòng chọn Bưu tá!");
        return;
      }
      // Gán Bưu tá
      const dataBuuTa = new FormData();
      dataBuuTa.append("buuTa", formData.buuTa);
      const result = await DriverService.ganBuuTa(selectedChuyen.id, dataBuuTa);
      alert(result.message);

    } else if (currentStatus === 'hoan_tat') {
      try {
        // Sửa lỗi: truyền luôn timeVeKho để ghi nhận thời gian về kho
        const result = await DriverService.nhapKmPhatSinh(formData.kmPhatSinh, formData.timeVeKho, selectedChuyen.id);
        alert(result.message);
        // Xoá chuyến sau khi nhập km phát sinh
        setChuyenData((prevData) =>
          prevData.filter((chuyen) => chuyen.id !== selectedChuyen.id)
        );
        setShowModal(false);
        return;
      } catch (error) {
        alert('Lỗi khi nhập Km phát sinh: ' + error.message);
        return;
      }
    }

    // Tạo formData gửi lên
    const data = new FormData();
    data.append('ma_cx', formData.ma_cx);
    data.append('maChuyen', formData.maChuyen);
    data.append('kmDau', formData.kmDau);
    data.append('kmNhanHang', formData.kmNhanHang);
    data.append('kmCuoi', formData.kmCuoi);
    data.append('trangThaiKetThuc', formData.trangThaiKetThuc);
    // Khi gửi form, thêm vào FormData gửi lên server:
    data.append('timeNhanChuyen', formData.timeNhanChuyen);
    data.append('timeNhanHang', formData.timeNhanHang);
    data.append('timeGiaoHangXong', formData.timeGiaoHangXong);
    data.append('timeHoanThanh', formData.timeHoanThanh);

    try {
      if (formData.anhNhanHang) {
        const resizedAnhNhanHang = await resizeImage(formData.anhNhanHang);
        data.append('anhNhanHang', resizedAnhNhanHang);
      }
      if (formData.anhGiaoHang) {
        const resizedAnhGiaoHang = await resizeImage(formData.anhGiaoHang);
        data.append('anhGiaoHang', resizedAnhGiaoHang);
      }

      // Lấy vị trí hiện tại
      const position = await new Promise((resolve, reject) =>
        navigator.geolocation.getCurrentPosition(resolve, reject)
      );
      data.append('lat', position.coords.latitude);
      data.append('lon', position.coords.longitude);

      const result = await urlService(data);
      alert(result.message);

      // Cập nhật local state
      setChuyenData((prevData) =>
        prevData.map((chuyen) =>
          chuyen.id === selectedChuyen.id
            ? { ...chuyen, trangThai: currentStatus }
            : chuyen
        )
      );
      setShowModal(false);
      setThayDoi(true);
    } catch (error) {
      alert('Không thể lấy vị trí hoặc có lỗi xảy ra: ' + error.message);
    }
  };

  // Hàm xử lý gán Bưu tá (giữ nguyên nếu cần dùng về sau)
  const handleGanBuuTa = async () => {
    try {
      if (!formData.buuTa) {
        alert("Vui lòng chọn Bưu tá!");
        return;
      }

      const data = new FormData();
      data.append("buuTa", formData.buuTa);

      const result = await DriverService.ganBuuTa(selectedChuyen.id, data);
      alert(result.message);
      setShowModal(false);
      setThayDoi(true);
    } catch (error) {
      alert("Lỗi khi gán Bưu tá: " + error.message);
    }
  };

  return (
    <Container className="mt-4">
      <h2 className="text-center mb-4">Danh Sách Chuyến Của Tài Xế</h2>
      <Row className="g-4">
        {chuyenData.map((chuyen) => (
          <Col key={chuyen.id} md={6} lg={4}>
            <Card>
              <Card.Body>
                <Card.Title>Mã Chuyến: {chuyen.id}</Card.Title>
                <Card.Text>Khách hàng: {chuyen.ten_khach_hang}</Card.Text>
                <Card.Text>
                  Ngày vận chuyển:{' '}
                  {new Date(chuyen.ngay_van_chuyen).toLocaleDateString()}
                </Card.Text>
                <Card.Text>Điểm đi: {chuyen.diem_di}</Card.Text>
                <Card.Text>Điểm đến: {chuyen.diem_den}</Card.Text>
                <Card.Text>Ghi chú: {chuyen.ghi_chu}</Card.Text>
                <Card.Text>Tài 1: {chuyen.tai_xe}</Card.Text>
                <Card.Text>Tài 2: {chuyen.tai_xe_2}</Card.Text>
                <Card.Text>Biển kiểm soát: {chuyen.bien_kiem_soat}</Card.Text>

                {chuyen.trang_thai === 'hoan_tat' && chuyen.trang_thai_ket_thuc !== 'chua_xac_nhan' ? (
                  <Card.Text>Km phát sinh: {chuyen.km_phat_sinh || '0'}</Card.Text>
                ) : (
                  <Card.Text>Chuyến chưa kết thúc</Card.Text>
                )}

                <div className="d-flex flex-wrap gap-2 mt-2">
                  {chuyen.routing && (
                    <Button variant="info" onClick={() => handleViewRouteClick(chuyen)}>
                      Xem đường đi
                    </Button>
                  )}
                  {chuyen.trang_thai === 'chua_nhan' && (
                    <Button variant="primary" onClick={() => handleButtonClick(chuyen)}>
                      Nhận chuyến
                    </Button>
                  )}
                  {chuyen.trang_thai === 'da_nhan' && (
                    <Button variant="primary" onClick={() => handleButtonClick(chuyen)}>
                      Cập nhật chuyến
                    </Button>
                  )}
                  {chuyen.trang_thai === 'capnhat_chuyen' && (
                    <Button variant="primary" onClick={() => handleButtonClick(chuyen)}>
                      Kết thúc chuyến
                    </Button>
                  )}
                  {chuyen.trang_thai === 'hoan_tat' &&
                    chuyen.trang_thai_ket_thuc === 'chua_xac_nhan' && (
                      <Button variant="primary" onClick={() => handleEndButtonClick(chuyen.id)}>
                        Hoàn thành chuyến
                      </Button>
                    )}
                  {chuyen.trang_thai === 'hoan_tat' &&
                    chuyen.trang_thai_ket_thuc !== 'chua_xac_nhan' && (
                      <Button variant="primary" onClick={() => handleNhapKmPhatSinh(chuyen)}>
                        Nhập Km phát sinh
                      </Button>
                    )}
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {modalMode === "receive"
              ? "Xác nhận đường đi và nhận chuyến"
              : modalMode === "view"
                ? "Xem đường đi"
                : "Nhập Km phát sinh"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Nếu chuyến có routing, hiển thị MapPreview (trừ khi đang nhập km phát sinh) */}
          {selectedChuyen && selectedChuyen.routing && modalMode !== "kmPhatSinh" && (
            <div className="mb-3">
              <MapPreview
                routePolyline={selectedChuyen.routing}
                originAddress={selectedChuyen.diem_di_thuc_te || selectedChuyen.diem_di}
                destinationAddress={selectedChuyen.diem_den_thuc_te || selectedChuyen.diem_den}
              />
            </div>
          )}

          {/* Form cho các trạng thái chua_nhan / da_nhan / capnhat_chuyen / hoan_tat */}
          {modalMode === "receive" && <Form>{generateFormContent()}</Form>}

          {/* Modal riêng cho nhập Km phát sinh (khi modalMode = kmPhatSinh) */}
          {modalMode === "kmPhatSinh" && (
            <>
              <p>{kmPhatSinhMessage}</p>
              <Form.Group className="mb-3">
                <Form.Label>Km phát sinh</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Nhập Km phát sinh"
                  min={0}
                  onChange={(e) => handleFormChange("kmPhatSinh", parseInt(e.target.value))}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Thời gian về kho</Form.Label>
                <Form.Control
                  type="datetime-local"
                  onChange={(e) => handleFormChange("timeVeKho", e.target.value)}
                  value={formData.timeVeKho}
                />
              </Form.Group>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            {modalMode === "receive" ? "Hủy" : "Đóng"}
          </Button>

          {modalMode === "receive" && (
            <Button variant="primary" onClick={submitForm}>
              Xác nhận
            </Button>
          )}
          {modalMode === "kmPhatSinh" && (
            <Button variant="primary" onClick={handleKmPhatSinhConfirm}>
              Xác nhận
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default TaiXeNhanChuyenComponent;
